<template>
  <div>
    <v-card>
      <system-configuration-tabs current-tab="ManageInstitutions" />
      <v-toolbar flat color="white" class="mt-4">
        <v-toolbar-title>Manage Institutions</v-toolbar-title>
        <v-spacer />
        <search-filter v-model="keywordSearch" />
        <v-btn color="secondary" dark @click="institutionDialog = true">
          Add
        </v-btn>
      </v-toolbar>
      <v-data-table :headers="headers" :items="institutions" :pagination.sync="pagination" :total-items="totalRecords" :loading="loading" :rows-per-page-items="rowsPerPageItems">
        <v-progress-linear slot="progress" color="secondary" indeterminate />
        <template slot="items" slot-scope="props">
          <td style="cursor:pointer" @click="props.expanded = !props.expanded">
            <i class="fas fa-chevron-right mr-4 expand-icon" :class="{rotate: props.expanded}" />
            {{ props.item.name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.active }}
          </td>
          <td class="text-xs-right">
            <v-icon small class="mr-2" @click="popEditInstitution(props.item)">
              edit
            </v-icon>
            <v-icon @click="deleteInstitution(props.item)">
              far fa-trash-alt
            </v-icon>
          </td>
        </template>
        <template v-slot:expand="props">
          <v-layout wrap class="py-5 px-3">
            <v-flex v-for="campus in props.item.campuses" :key="campus.id" md3 class="px-3">
              <v-card elevation="4">
                <v-card-title primary-title>
                  <div>
                    <h4 class="subheading mb-0">
                      {{ campus.name }}
                    </h4>
                    <p class="mb-3">
                      {{ campus.address }} <span v-if="campus.address2">{{ campus.address2 }}</span> {{ campus.city }}, {{ campus.state }} {{ campus.zip }}
                    </p>
                    <p>
                      Code: {{ campus.code }}<br>
                      <template v-if="campus.phone">
                        Phone: {{ campus.phone }}<br>
                      </template>
                      <template v-if="campus.secondaryPhone">
                        Secondary Phone: {{ campus.secondaryPhone }}<br>
                      </template>
                      <template v-if="campus.fax">
                        Fax: {{ campus.fax }}
                      </template>
                    </p>
                  </div>
                </v-card-title>

                <v-card-actions>
                  <v-btn flat color="red" @click="deleteCampus(campus)">
                    Delete
                  </v-btn>
                  <v-spacer />
                  <v-btn flat color="blue" @click="popEditCampus(campus)">
                    Edit
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex md3 class="px-3">
              <v-card elevation="4" height="100%" class="py-5" @click.native="popAddCampus(props.item)">
                <div class="justify-content-center align-items-center headline" style="height:100%;cursor:pointer;display:flex">
                  <div class="text-center">
                    <div class="pb-3">
                      <v-icon large>
                        fas fa-plus-circle
                      </v-icon>
                    </div>
                    <div>
                      Add a New Campus
                    </div>
                  </div>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="institutionDialog" width="500">
      <v-card>
        <alert-banner :msg="alertMessage" />
        <form @submit.prevent="saveInstitution">
          <v-card-title class="headline lighten-2" primary-title>
            {{ editInstitutionObject.id ? 'Edit' : 'Add' }} Instutition
          </v-card-title>
          <v-container fill-height fluid>
            <v-layout wrap justify-center>
              <v-flex xs11>
                <v-text-field v-model="institutionForm.name" label="Institution Name" required />
                <v-text-field v-model="institutionForm.code" label="USD Code" />
                <v-switch v-model="institutionForm.active" label="Is Active" />
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn color="danger" flat @click.native="institutionDialog = false">
              cancel
            </v-btn>
            <v-btn color="primary" flat type="submit" :loading="saving">
              save
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="campusDialog" width="500">
      <v-card>
        <alert-banner :msg="alertMessage" />
        <form @submit.prevent="saveCampus">
          <v-card-title class="headline lighten-2" primary-title>
            {{ campusForm.id ? 'Edit' : 'Add' }} Campus
          </v-card-title>
          <v-container fill-height fluid>
            <v-layout wrap justify-center>
              <v-flex xs11>
                <v-text-field v-model="campusForm.name" label="Campus Name" required />
                <v-text-field v-model="campusForm.code" label="Code" />
                <v-text-field v-model="campusForm.address" label="Address" />
                <v-text-field v-model="campusForm.address2" label="Address 2" />
                <v-text-field v-model="campusForm.city" label="City" />
                <v-select v-model="campusForm.state" :items="stateList.states" name="state" label="State" item-text="abbreviation" />
                <v-text-field v-model="campusForm.zip" label="Zip" />
                <v-text-field v-model="campusForm.phone" label="Phone #" />
                <v-text-field v-model="campusForm.secondaryPhone" label="Secondary Phone #" />
                <v-text-field v-model="campusForm.fax" label="Fax #" />
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-spacer />
            <v-btn color="danger" flat @click.native="campusDialog = false">
              cancel
            </v-btn>
            <v-btn color="primary" flat type="submit" :loading="saving">
              save
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import _ from 'lodash';
  import axios from 'axios';
  import localforage from 'localforage';
  import SystemConfigurationTabs from './components/SystemConfigurationTabs.vue';
  import StatesJson from '../../Constants/States.json';

  export default { 
    parent: true,

    components: {
      SystemConfigurationTabs,
    },

    props: {
      isAdmin: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      loading: true,
      institutions: [],
      saving: false,
      totalRecords: 0,
      rowsPerPageItems: [20, 50, 75, 100],
      pagination: {
        descending: false, page: 1, rowsPerPage: 20, sortBy: 'name',
      },
      headers: [
        {
          text: 'Name', value: 'name', align: 'left', sortable: true,
        },
        {
          text: 'Active', align: 'center', value: 'active', sortable: true,
        },
        { text: '', align: 'right', sortable: false },
      ],
      keywordSearch: '',

      defaultInstitution: {
        name: '',
        usdCode: '',
        active: true,
      },

      institutionForm: {
        name: '',
        usdCode: '',
        active: true,
      },

      defaultCampus: {
        address: '',
        address2: '',
        city: '',
        code: '',
        fax: '',
        name: '',
        phone: '',
        secondaryPhone: '',
        state: '',
        zip: '',
      },

      campusForm: {
        address: '',
        address2: '',
        city: '',
        code: '',
        fax: '',
        name: '',
        phone: '',
        secondaryPhone: '',
        state: '',
        zip: '',
        },

      stateList: StatesJson,
      institutionDialog: false,
      editInstitutionObject: {},
      campusDialog: false,
      editCampusObject: {},
    }),

    watch: {
      pagination: {
        handler(newval, oldval) {
          if (!_.isEqual(newval, oldval)) {
            this.getInstitutions();
          }
        },
        deep: true,
      },

      'pagination.rowsPerPage': function (val) {
        localforage.setItem('ManageInstitutionsGrid:RowsPerPage', val);
      },

      keywordSearch() {
        this.processSearch();
      },

      institutionDialog(val) {
        if (!val) {
          setTimeout(() => {
            this.institutionForm = Object.assign({}, this.defaultInstitution);
            this.editInstitutionObject = {};
          }, 300);
        } else if (val && Object.keys(this.editInstitutionObject).length > 0) {
          this.institutionForm = this.editInstitutionObject;
        }
      },

      campusDialog(val) {
        if (!val) {
          setTimeout(() => {
            this.campusForm = Object.assign({}, this.defaultCampus);
            this.editCampusObject = {};
          }, 300);
        } else if (val && Object.keys(this.editCampusObject).length > 0) {
          this.campusForm = this.editCampusObject;
        }
      },
    },

    mounted() {
      localforage.getItem('ManageInstitutionsGrid:RowsPerPage').then((value) => {
        this.pagination.rowsPerPage = value || 20;
        this.getInstitutions();
      });
    },

    methods: {
      async getInstitutions() {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;
        const sortDirection = descending ? `${sortBy} DESC` : `${sortBy} ASC`;
        this.loading = true;
        const { data } = await axios.get(`/api/institutions/paged?currentPage=${page}&pageSize=${rowsPerPage}&sortDir=${sortDirection}&filter=${this.keywordSearch}`);
        this.institutions = data.resultItems;
        this.totalRecords = data.totalRecords;
        this.loading = false;
      },

      async saveInstitution() {
        this.saving = true;
        try {
          if (this.editInstitutionObject.id) {
            await axios.patch(`/api/institutions/${this.editInstitutionObject.id}`, this.institutionForm);
          } else {
            await axios.post('/api/institutions', this.institutionForm);
          }
          this.institutionDialog = false;
          this.getInstitutions();
        } catch (error) {
          this.processErrors(error, this.institutionForm);
        } finally {
          this.saving = false;
        }
      },

      async saveCampus() {
        this.saving = true;
        try {
          if (this.editCampusObject.id) {
            await axios.patch(`/api/institutions/${this.campusForm.institutionId}/campuses/${this.campusForm.id}`, this.campusForm);
          } else {
            await axios.post(`/api/institutions/${this.campusForm.institutionId}/campuses`, this.campusForm);
          }
          this.campusDialog = false;
          this.getInstitutions();
        } catch (error) {
          this.processErrors(error, this.campusForm);
        } finally {
          this.saving = false;
        }
      },

      async deleteInstitution(item) {
      const result = confirm('Are you sure you want to delete this institution?'); // eslint-disable-line
        if (result) {
          await axios.delete(`/api/institutions/${item.id}`);
          await this.getInstitutions();
        }
      },

      async deleteCampus(campus) {
      const result = confirm('Are you sure you want to delete this campus?'); // eslint-disable-line
        if (result) {
          await axios.delete(`/api/institutions/${campus.institutionId}/campuses/${campus.id}`);
          await this.getInstitutions();
        }
      },

      popEditCampus(item) {
        this.campusDialog = true;
        this.editCampusObject = JSON.parse(JSON.stringify(item));
      },

      popAddCampus(institution) {
        this.campusDialog = true;
        this.campusForm.institutionId = institution.id;
      },

      popEditInstitution(item) {
        this.institutionDialog = true;
        this.editInstitutionObject = JSON.parse(JSON.stringify(item));
      },

      processSearch: _.debounce(function () {
        this.getInstitutions();
      }, 600),
    },
  };
</script>